<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="tola-logo-fallback-gradient"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
      >
        <stop offset="0" stop-color="#7C2FE0" />
        <stop offset="0.42" stop-color="#E0219A" />
        <stop offset="0.74" stop-color="#F5403A" />
        <stop offset="1" stop-color="#FB9A1B" />
      </linearGradient>
      <mask id="tola-logo-fallback-cutout">
        <rect width="32" height="32" fill="#fff" />
        <path
          d="M9.6 12.6h12.8"
          stroke="#000"
          stroke-width="6.6"
          stroke-linecap="round"
        />
        <path
          d="M16 12.6v13.4"
          stroke="#000"
          stroke-width="5.4"
          stroke-linecap="round"
        />
      </mask>
    </defs>
    <path
      d="M13.12 2.39 Q16 1 18.88 2.39 L27.62 6.61 Q30.5 8 30.5 11.2 L30.5 20.8 Q30.5 24 27.62 25.39 L18.88 29.61 Q16 31 13.12 29.61 L4.38 25.39 Q1.5 24 1.5 20.8 L1.5 11.2 Q1.5 8 4.38 6.61 Z"
      fill="url(#tola-logo-fallback-gradient)"
      mask="url(#tola-logo-fallback-cutout)"
    />
  </svg>
</template>
